// extracted by mini-css-extract-plugin
export default {"root":"Header_root__dcArq","logo":"Header_logo__9QdMH","closeBurger":"Header_closeBurger__kvYwf"};